<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#159bd1"
  type="square-jelly-box"
  [fullScreen]="true"
>
  <p style="color: #159bd1"> Loading... </p>
</ngx-spinner>
<ngx-sonner-toaster position="bottom-right" [richColors]="true" />
<router-outlet></router-outlet>
